import t from "./exported-variables.scss.js";
var e;
const o = parseInt(((e = t) == null ? void 0 : e.screenBreakpointMedium) || "768");
var r;
const E = parseInt(((r = t) == null ? void 0 : r.screenBreakpointLarge) || "1224");
export {
  E as SCREEN_BREAKPOINT_LARGE,
  o as SCREEN_BREAKPOINT_MEDIUM
};
